import { Text } from "@mantine/core";
import type { FixedPricesProductId } from "@project/common";
import type { FC } from "react";
import { has } from "es-toolkit/compat";
import { FormattedMessage } from "react-intl";

const ProductToDescription: Record<FixedPricesProductId, FC> = {
  mapka_basic_support: () => {
    return (
      <Text size="sm" fw={500}>
        <FormattedMessage
          id="title.basicSupport"
          defaultMessage="Basic Support"
        />
      </Text>
    );
  },
  mapka_business_support: () => {
    return (
      <Text size="sm" fw={500}>
        <FormattedMessage
          id="title.businessSupport"
          defaultMessage="Business Support"
        />
      </Text>
    );
  },
  mapka_data_catalog: () => {
    return (
      <Text size="sm" fw={500}>
        <FormattedMessage
          id="title.dataCatalog"
          defaultMessage="Data Catalog"
        />
      </Text>
    );
  },
  mapka_no_attribution: () => {
    return (
      <Text size="sm" fw={500}>
        <FormattedMessage
          id="title.noAttribution"
          defaultMessage="No Mapka attribution"
        />
      </Text>
    );
  },
};

export interface ProductDescriptionProps {
  productId: string;
  description?: string;
};

export const ProductDescription: FC<ProductDescriptionProps> = ({ productId, description }) => {
  const hasDescription = has(ProductToDescription, productId);

  if (hasDescription) {
    const ProductDescriptionProduct = ProductToDescription[productId as FixedPricesProductId];
    return <ProductDescriptionProduct />;
  }

  return description;
};
